export default __webpack_public_path__ + "static/media/file-zip.ad49116a.svg";